// ═══════════════════════════════════════════════════════════
// نظام ERP - جمعية الدعوة والإرشاد وتوعية الجاليات بشمال الرياض
// ملف الثوابت المشتركة — V2 (محدّث)
// التعديلات: إضافة دور السكرتير + حذف الإيموجي + الخطة التشغيلية + الاقتباسات اليومية
// ═══════════════════════════════════════════════════════════

// ───── الألوان الأساسية (من دليل الهوية الرسمي V03|2026) ─────
export const C = {
  primary: "#003d58",
  primaryDark: "#002a3e",
  accent: "#dcc160",
  teal: "#00b4a2",
  bg: "#F7F8FA",
  sidebar: "#003d58",
  success: "#2D8B59",
  warning: "#D4A843",
  danger: "#C4513D",
  text: "#003d58",
  textLight: "#5a7a8a",
  border: "#E2E8ED",
  white: "#FFFFFF",
  cardBg: "#FFFFFF",
};

// ───── 15 لون للقوالب التلقائية ─────
export const TEMPLATE_COLORS = [
  { name: "أزرق داكن", hex: "#1B4F72", light: "#D4E6F1" },
  { name: "أخضر", hex: "#196F3D", light: "#D5F5E3" },
  { name: "ذهبي", hex: "#8A6F08", light: "#FCF3CF" }, // أغمق لتباين النص الأبيض (BUG-052)
  { name: "بنفسجي", hex: "#6C3483", light: "#E8DAEF" },
  { name: "برتقالي", hex: "#BA4A00", light: "#FAE5D3" },
  { name: "أحمر داكن", hex: "#922B21", light: "#F2D7D5" },
  { name: "تركواز", hex: "#117864", light: "#D1F2EB" },
  { name: "زيتي", hex: "#7D6608", light: "#FEF9E7" },
  { name: "نبيتي", hex: "#641E16", light: "#F5B7B1" },
  { name: "رمادي أزرق", hex: "#34495E", light: "#D6DBDF" },
  { name: "أخضر فاتح", hex: "#1E8449", light: "#D5F5E3" }, // أغمق لتباين النص الأبيض (BUG-052)
  { name: "كحلي", hex: "#1A237E", light: "#C5CAE9" },
  { name: "وردي داكن", hex: "#AD1457", light: "#F8BBD0" },
  { name: "بني", hex: "#4E342E", light: "#D7CCC8" },
  { name: "سماوي", hex: "#0277BD", light: "#B3E5FC" },
];

// ───── الأدوار (+ سكرتير مكتب المدير التنفيذي) ─────
export const ROLES = {
  EXEC: "exec",
  SECRETARY: "secretary",
  SYSTEM: "system",
  COMMUNITIES: "communities",
  MOSQUES: "mosques",
  FINANCE: "finance",
  FUNDRAISING: "fundraising",
  COMMS: "comms",
  WOMEN: "women",
  VOLUNTEER: "volunteer",
  PREACHER: "preacher",
  ACCOUNTANT: "accountant",
  DATA_ENTRY: "data_entry",
};

// ───── أسماء الأدوار بالعربي ─────
export const ROLE_NAMES = {
  exec: "المسؤول التنفيذي",
  secretary: "سكرتير مكتب المدير التنفيذي",
  system: "مدير النظام",
  communities: "مدير إدارة الجاليات",
  mosques: "مدير إدارة الدعوة والمساجد",
  finance: "المدير المالي",
  fundraising: "مدير تنمية الموارد والأوقاف",
  comms: "مدير الاتصال المؤسسي",
  women: "مديرة الإدارة النسائية",
  volunteer: "مدير إدارة التطوع",
  preacher: "داعية",
  accountant: "محاسب",
  data_entry: "مدخل بيانات",
};

// ───── الصلاحيات ─────
export const ROLE_PERMISSIONS = {
  exec: ["dashboard", "communities", "mosques", "women", "events", "finance", "donors", "fundraising", "hr", "volunteer", "comms", "governance", "users"],
  // إدارة المستخدمين للمسؤول التنفيذي ومدير النظام فقط — ليست للسكرتير (BUG-019)
  secretary: ["dashboard", "communities", "mosques", "women", "events", "finance", "donors", "fundraising", "hr", "volunteer", "comms", "governance"],
  system: ["dashboard", "communities", "mosques", "women", "events", "finance", "donors", "fundraising", "hr", "volunteer", "comms", "governance", "users"],
  communities: ["dashboard", "communities", "events", "volunteer"],
  mosques: ["dashboard", "mosques", "events", "volunteer"],
  finance: ["dashboard", "finance", "donors", "hr", "fundraising"],
  // المتبرعون (donors) لمدير تنمية الموارد بدون باقي المالية
  fundraising: ["dashboard", "donors", "fundraising", "events", "comms"],
  comms: ["dashboard", "comms", "events"],
  women: ["dashboard", "women", "events", "volunteer"],
  volunteer: ["dashboard", "volunteer", "events"],
  preacher: ["dashboard", "communities", "mosques", "events"],
  accountant: ["dashboard", "finance", "donors"],
  data_entry: ["dashboard", "communities", "mosques", "events"],
};

// ───── من يعدّل الإعدادات (BUG-050، قرار طارق 2026-10-06) ─────
// الحسابات البنكية، الخطة التشغيلية، الأعداد والنسب (جدول app_settings). نفس القائمة في policies migration 014.
export const SETTINGS_EDITORS = ["exec", "finance", "system"];
export const canEditSettings = (role) => SETTINGS_EDITORS.includes(role);

// آيبان سعودي: SA + 22 رقم (نفس قيد chk_bank_iban في migration 014)
export const normalizeIban = (v) => String(v || "").replace(/\s+/g, "").toUpperCase();
export const isValidIban = (v) => /^SA\d{22}$/.test(normalizeIban(v));

// ───── الموديولات ─────
export const MODULES = {
  DASHBOARD: "dashboard", COMMUNITIES: "communities", MOSQUES: "mosques",
  WOMEN: "women", EVENTS: "events", FINANCE: "finance", FUNDRAISING: "fundraising",
  HR: "hr", VOLUNTEER: "volunteer", COMMS: "comms", GOVERNANCE: "governance", USERS: "users",
};

// ───── بيانات الجمعية ─────
export const ORG = {
  name: "جمعية الدعوة والإرشاد وتوعية الجاليات بشمال الرياض",
  shortName: "دعوة شمال الرياض",
  code: "CNR",
  location: "حي المحمدية - شمال الرياض - السعودية",
  founded: "1413هـ",
  registrationNo: "3496",
  website: "cnr.org.sa",
  store: "store.cnr.org.sa",
  phone: "0114704466",
  phone2: "0114705222",
  mobile: "0550030381",
  email: "info@haqweb.com",
};

// ───── قائمة الإدارات الموحّدة (BUG-014) — المصدر الوحيد لأسماء الإدارات في كل الشاشات ─────
// id = مفتاح الموديول/الدور، name = الاسم المحفوظ في الداتابيز
export const DEPARTMENTS = [
  { id: "exec", name: "الإدارة العليا" },
  { id: "communities", name: "إدارة الجاليات" },
  { id: "mosques", name: "إدارة الدعوة والمساجد" },
  { id: "women", name: "الإدارة النسائية" },
  { id: "finance", name: "الإدارة المالية" },
  { id: "hr", name: "الشؤون الإدارية" },
  { id: "fundraising", name: "تنمية الموارد والأوقاف" },
  { id: "comms", name: "الاتصال المؤسسي" },
  { id: "volunteer", name: "إدارة التطوع" },
  { id: "events", name: "الفعاليات" },
  { id: "governance", name: "الحوكمة" },
  { id: "board", name: "مجلس الإدارة" },
  { id: "donor_crm", name: "المتبرعين" },
  { id: "it", name: "تقنية المعلومات" },
  { id: "services", name: "الخدمات المساندة" },
];
export const DEPARTMENT_NAMES = DEPARTMENTS.map((d) => d.name);
// moduleKey (تبويب "الشؤون المالية") → اسم الإدارة
export const deptNameOf = (id) => DEPARTMENTS.find((d) => d.id === id)?.name || id;
// أسماء قديمة/مختصرة كانت مستخدمة في شاشات مختلفة → الاسم الموحّد (للسجلات المحفوظة قبل التوحيد)
const DEPT_ALIASES = {
  "الجاليات": "إدارة الجاليات", "المساجد": "إدارة الدعوة والمساجد", "النسائية": "الإدارة النسائية",
  "إدارية": "الشؤون الإدارية", "الإعلام": "الاتصال المؤسسي", "الاتصال": "الاتصال المؤسسي",
  "تنمية الموارد": "تنمية الموارد والأوقاف", "التطوع": "إدارة التطوع", "المالية": "الإدارة المالية",
  "الشؤون المالية": "الإدارة المالية", "إدارة الشؤون المالية": "الإدارة المالية",
};
export const normalizeDept = (name) => DEPT_ALIASES[String(name || "").trim()] || String(name || "").trim();

// ───── الصناديق (BUG-013) — قيمة "الحساب" الموحّدة في التبرعات وطلبات الصرف ─────
export const FUNDS = [
  { id: "general", name: "الحساب العام", bankType: "عام" },
  { id: "zakat", name: "حساب الزكاة", bankType: "زكاة" },
  { id: "waqf", name: "حساب الوقف", bankType: "وقف" },
];
export const FUND_NAMES = FUNDS.map((f) => f.name);
// أي نص حساب قديم (مثل "اسم - بنك" أو "زكاة") → الصندوق
export const fundOf = (account) => {
  const s = String(account || "");
  if (s.includes("زكاة")) return FUNDS[1];
  if (s.includes("وقف")) return FUNDS[2];
  return FUNDS[0];
};

// ───── الجاليات (بدون إيموجي) ─────
export const COMMUNITIES = [
  { id: 1, name: "الجالية الهندية", lang: "هندية" },
  { id: 2, name: "الجالية البنغالية", lang: "بنغالية" },
  { id: 3, name: "الجالية الفلبينية", lang: "فلبينية" },
  { id: 4, name: "الجالية الإثيوبية", lang: "أمهرية" },
  { id: 5, name: "الجالية النيبالية", lang: "نيبالية" },
  { id: 6, name: "جالية أوردو/بشتو", lang: "أوردو" },
  { id: 7, name: "الجالية الإنجليزية", lang: "إنجليزية" },
  { id: 8, name: "الجالية الصينية", lang: "صينية" },
  { id: 9, name: "جاليات أخرى", lang: "متعدد" },
];

// ───── اللغات والجنسيات الموحّدة (BUG-036) — نفس القيم في كل النماذج والاستيراد ─────
export const LANGUAGES = ["هندية", "بنغالية", "فلبينية", "أمهرية", "نيبالية", "أوردو", "إنجليزية", "صينية", "إندونيسية", "فرنسية", "عربية"];
export const NATIONALITIES = ["هندي", "بنغالي", "فلبيني", "إندونيسي", "إثيوبي", "نيبالي", "باكستاني", "سريلانكي", "صيني", "بريطاني", "أمريكي", "أفريقي", "أوروبي", "أخرى"];
const LANG_ALIASES = {
  "هندي": "هندية", "hindi": "هندية", "بنغالي": "بنغالية", "bengali": "بنغالية", "bangla": "بنغالية",
  "فلبيني": "فلبينية", "تاغالوغ": "فلبينية", "tagalog": "فلبينية", "filipino": "فلبينية",
  "أمهري": "أمهرية", "amharic": "أمهرية", "نيبالي": "نيبالية", "nepali": "نيبالية",
  "أردو": "أوردو", "اوردو": "أوردو", "urdu": "أوردو", "إنجليزي": "إنجليزية", "انجليزي": "إنجليزية", "انجليزية": "إنجليزية", "english": "إنجليزية",
  "صيني": "صينية", "chinese": "صينية", "إندونيسي": "إندونيسية", "indonesian": "إندونيسية",
  "فرنسي": "فرنسية", "french": "فرنسية", "عربي": "عربية", "العربية": "عربية", "arabic": "عربية",
};
const NATIONALITY_ALIASES = {
  "india": "هندي", "indian": "هندي", "هندية": "هندي", "bangladesh": "بنغالي", "bangladeshi": "بنغالي",
  "philippines": "فلبيني", "filipino": "فلبيني", "indonesia": "إندونيسي", "indonesian": "إندونيسي",
  "ethiopia": "إثيوبي", "ethiopian": "إثيوبي", "nepal": "نيبالي", "nepali": "نيبالي",
  "pakistan": "باكستاني", "pakistani": "باكستاني", "sri lanka": "سريلانكي", "sri lankan": "سريلانكي",
  "china": "صيني", "chinese": "صيني", "uk": "بريطاني", "british": "بريطاني", "usa": "أمريكي", "american": "أمريكي",
};
const aliasOf = (map, v) => map[String(v || "").trim().toLowerCase()] || map[String(v || "").trim()] || String(v || "").trim();
export const normalizeLang = (v) => aliasOf(LANG_ALIASES, v);
export const normalizeNationality = (v) => aliasOf(NATIONALITY_ALIASES, v);

// ───── أنواع أحداث المساجد (بدون إيموجي) ─────
export const EVENT_TYPES = {
  WORD: { id: "word", name: "كلمة دعوية", duration: "5 دقائق", color: "#196F3D", lightColor: "#D5F5E3" },
  LESSON: { id: "lesson", name: "درس علمي", duration: "ساعة", color: "#1B4F72", lightColor: "#D4E6F1" },
  DAY: { id: "day", name: "يوم علمي", duration: "يوم كامل", color: "#B7950B", lightColor: "#FCF3CF" },
  COURSE: { id: "course", name: "دورة علمية", duration: "3 أيام فأكثر", color: "#6C3483", lightColor: "#E8DAEF" },
};

// تاريخ النهاية: لليوم العلمي (اختياري — نفس اليوم افتراضياً) وإلزامي للدورة (3 أيام فأكثر) — BUG-033
// نفس قيود القاعدة chk_event_end_date و chk_course_min_3_days (migration 005)
export const MULTI_DAY_EVENT_TYPES = ["day", "course"];
export const eventDatesError = ({ type, date, endDate }) => {
  if (!MULTI_DAY_EVENT_TYPES.includes(type)) return "";
  if (!date || !endDate) return type === "course" ? "أدخل تاريخ نهاية الدورة" : "";
  if (endDate < date) return "تاريخ النهاية قبل تاريخ البداية";
  if (type === "course" && endDate < addDaysISO(2, `${date}T00:00:00`)) return "الدورة العلمية 3 أيام فأكثر";
  return "";
};

// ───── مراحل المسار الإجرائي (بدون إيموجي) ─────
export const EVENT_STAGES = [
  { id: 1, name: "تنسيق مسبق", desc: "تحديد المسجد والموعد" },
  { id: 2, name: "التنسيق مع المشايخ", desc: "تأكيد الموضوع والوقت مع الشيخ/الداعية" },
  { id: 3, name: "إعداد القالب", desc: "تصميم بوستر/إعلان" },
  { id: 4, name: "التنفيذ", desc: "الحدث وتسجيل الحضور" },
  { id: 5, name: "التقرير", desc: "عدد الحضور والملاحظات" },
];

// ───── مميزات أحداث المساجد (جديد) ─────
export const EVENT_PERKS = [
  { id: "books", name: "كتب شرعية", default: true },
  { id: "certificate", name: "شهادة حضور", default: true },
  { id: "custom", name: "هدايا أخرى", default: false },
];

// ───── أنواع العضويات ─────
export const MEMBERSHIP_TYPES = [
  { id: "student", name: "عضوية طالب", fee: 0, duration: 12 },
  { id: "associate", name: "عضوية منتسب", fee: 100, duration: 12 },
  { id: "family", name: "عضوية أسرة", fee: 300, duration: 12 },
  { id: "active", name: "عضوية فعالة", fee: 500, duration: 12 },
];

// ───── المشاريع الرئيسية ─────
export const MAIN_PROJECTS = [
  { id: "new_muslim", name: "كفالة مسلم جديد", desc: "تعريف المسلم الجديد بدينه" },
  { id: "preacher", name: "كفالة داعية", desc: "تفريغ دعاة متخصصين" },
  { id: "umrah", name: "كفالة معتمر", desc: "رحلات عمرة مجانية" },
  { id: "boshair", name: "ملتقيات بشائر الخير", desc: "فعاليات دعوية للجاليات" },
  { id: "compass", name: "مشروع البوصلة", desc: "إيصال الإسلام إلى أوروبا" },
  { id: "fatiha", name: "علمني الفاتحة وقصار السور", desc: "تعليم القرآن للمسلمين الجدد" },
];

// ───── مستويات التعليم للمسلم الجديد (جديد) ─────
export const EDUCATION_LEVELS = ["مبتدئ", "متوسط", "متقدم"];

// ───── حالات وثيقة المسلم الجديد (جديد) ─────
export const CERTIFICATE_STATUS = {
  issued: "أُصدرت", not_issued: "لم تُصدر",
  received: "استلم", not_received: "لم يستلم",
};

// ───── أحاديث نبوية وآيات قرآنية يومية ─────
export const DAILY_QUOTES = [
  { text: "إن الله لا يضيع أجر المحسنين", source: "التوبة: 120" },
  { text: "خيركم من تعلّم القرآن وعلّمه", source: "رواه البخاري" },
  { text: "من دعا إلى هدى كان له من الأجر مثل أجور من تبعه", source: "رواه مسلم" },
  { text: "وما تقدموا لأنفسكم من خير تجدوه عند الله", source: "البقرة: 110" },
  { text: "إنما الأعمال بالنيات وإنما لكل امرئ ما نوى", source: "متفق عليه" },
  { text: "من سلك طريقاً يلتمس فيه علماً سهّل الله له به طريقاً إلى الجنة", source: "رواه مسلم" },
  { text: "الدال على الخير كفاعله", source: "رواه مسلم" },
  { text: "ادع إلى سبيل ربك بالحكمة والموعظة الحسنة", source: "النحل: 125" },
  { text: "وتعاونوا على البر والتقوى", source: "المائدة: 2" },
  { text: "من كان يؤمن بالله واليوم الآخر فليقل خيراً أو ليصمت", source: "متفق عليه" },
  { text: "إن الله يحب إذا عمل أحدكم عملاً أن يتقنه", source: "رواه البيهقي" },
  { text: "ما نقصت صدقة من مال", source: "رواه مسلم" },
  { text: "وقل ربّ زدني علماً", source: "طه: 114" },
  { text: "خير الناس أنفعهم للناس", source: "حسّنه الألباني" },
  { text: "يسّروا ولا تعسّروا وبشّروا ولا تنفّروا", source: "متفق عليه" },
  { text: "من يرد الله به خيراً يفقهه في الدين", source: "متفق عليه" },
  { text: "إنما بعثت لأتمم مكارم الأخلاق", source: "رواه أحمد" },
  { text: "وجعلنا من الماء كل شيء حي", source: "الأنبياء: 30" },
  { text: "ومن أحسن قولاً ممن دعا إلى الله وعمل صالحاً", source: "فصلت: 33" },
  { text: "رب اجعلني مقيم الصلاة ومن ذريتي", source: "إبراهيم: 40" },
  { text: "بلّغوا عني ولو آية", source: "رواه البخاري" },
  { text: "الكلمة الطيبة صدقة", source: "متفق عليه" },
  { text: "إن مع العسر يسراً", source: "الشرح: 6" },
  { text: "وَمَن تطوّع خيراً فإن الله شاكرٌ عليم", source: "البقرة: 158" },
  { text: "المسلم من سلم المسلمون من لسانه ويده", source: "متفق عليه" },
  { text: "طلب العلم فريضة على كل مسلم", source: "رواه ابن ماجه" },
  { text: "لا يشكر الله من لا يشكر الناس", source: "رواه أبو داود" },
  { text: "كن في الدنيا كأنك غريب أو عابر سبيل", source: "رواه البخاري" },
  { text: "واصبر وما صبرك إلا بالله", source: "النحل: 127" },
  { text: "فبما رحمة من الله لنت لهم", source: "آل عمران: 159" },
  { text: "ربنا آتنا في الدنيا حسنة وفي الآخرة حسنة", source: "البقرة: 201" },
];

export const getDailyQuote = () => DAILY_QUOTES[new Date().getDate() % DAILY_QUOTES.length];

// ═══════════════════════════════════════════════════════════
// الدوال المساعدة
// ═══════════════════════════════════════════════════════════

// ───── التواريخ بالتوقيت المحلي (BUG-044) ─────
// toISOString() بيرجع تاريخ UTC — بين 12 و 3 فجراً بتوقيت الرياض بيطلع تاريخ أمس
const pad2 = (x) => String(x).padStart(2, "0");
export const isoDate = (d) => {
  const x = d instanceof Date ? d : new Date(d);
  return `${x.getFullYear()}-${pad2(x.getMonth() + 1)}-${pad2(x.getDate())}`;
};
export const todayISO = () => isoDate(new Date());
export const addDaysISO = (days, from = new Date()) => { const x = new Date(from); x.setDate(x.getDate() + days); return isoDate(x); };
// إضافة أشهر بالتقويم (مش 30 يوم × عدد الأشهر — BUG-058)
export const addMonthsISO = (months, from = new Date()) => { const x = new Date(from); x.setMonth(x.getMonth() + months); return isoDate(x); };

export const fmt = (n) => {
  if (n === null || n === undefined || isNaN(n)) return "0";
  return Number(n).toLocaleString("en-US");
};

export const fmtCurrency = (n) => `${fmt(n)} ر.س`;

export const fmtDate = (date) => {
  if (!date) return "";
  // أرقام لاتينية في كل النظام + التقويم صريح (BUG-066)
  return new Date(date).toLocaleDateString("ar-SA-u-nu-latn", { year: "numeric", month: "long", day: "numeric", calendar: "gregory" });
};

export const fmtHijri = (date) => {
  if (!date) return "";
  // تقويم أم القرى الرسمي (وليس islamic الحسابي) — BUG-066
  return new Date(date).toLocaleDateString("ar-SA-u-ca-islamic-umalqura-nu-latn", { year: "numeric", month: "long", day: "numeric" });
};

export const fmtDateTime = (date) => {
  if (!date) return "";
  return new Date(date).toLocaleString("ar-SA-u-nu-latn", { year: "numeric", month: "short", day: "numeric", hour: "2-digit", minute: "2-digit", calendar: "gregory" });
};

export const getGreeting = () => {
  const h = new Date().getHours();
  if (h < 5) return "ليلة مباركة";
  if (h < 12) return "صباح الخير";
  if (h < 17) return "مساء الخير";
  if (h < 20) return "مساء النور";
  return "أمسية طيبة";
};

export const genId = () => `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
export const pct = (num, total) => (!total || total === 0) ? 0 : Math.round((num / total) * 100);
export const nextTemplateColor = (index) => TEMPLATE_COLORS[index % TEMPLATE_COLORS.length];

export const EVENT_STATUS = {
  planned: { name: "مخطط", color: C.textLight },
  confirmed: { name: "مؤكد", color: C.warning },
  executed: { name: "منفذ", color: C.primary },
  completed: { name: "مكتمل", color: C.success },
  cancelled: { name: "ملغي", color: C.danger },
};

export default C;
